interface ThemeLogoProps {
  alt?: string;
  height?: number;
  className?: string;
}

/**
 * Theme-aware wordmark. Renders both variants and lets the `.dark` class
 * decide via CSS. This is immune to hydration flashes and next-themes state
 * drifting from the class actually applied to <html>.
 */
export function ThemeLogo({
  alt = "Thyra AI",
  height = 28,
  className,
}: ThemeLogoProps) {
  return (
    <>
      <img
        src="/logo/dark.svg"
        alt={alt}
        height={height}
        fetchPriority="high"
        className={`dark:hidden ${className ?? ""}`}
      />
      <img
        src="/logo/light.svg"
        alt={alt}
        height={height}
        fetchPriority="high"
        className={`hidden dark:block ${className ?? ""}`}
      />
    </>
  );
}
